import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { registerUser, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateUserData } from "../../store/appSlice";

export default function DoctorRegistrationSuccess() {
  pageTitle("Complete PRofile Registration");

  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.appSlice.userData);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState("IN");
  const [gender, setGender] = useState(1);
  const [mobile, setMobile] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData?.mobile_number) {
      navigate("/doctor-profile");
    }
  }, [userData, navigate]);

  console.log({ userData });

  const mapCountries = countries.map((it) => ({ label: it.country_name, value: it.phone_code }));

  const onSelectCountryItem = (c) => {
    setSelectedCountry(c);
  };
  const handleSubmitClick = async () => {
    if (mobile === "") {
      toast.error("Mobile number is required");
      return;
    }
    if (!selectedCountry) {
      toast.error("Country is required");
      return;
    }

    if (mobile != "" && mobile.length < 8) {
      toast.error("Invalid mobile number");
      return;
    }
    const payload = {
      identity: userData.identity,
      phone_number: `${mobile} ${selectedPhoneCountry}`,
      country_code: selectedCountry,
      gender: gender,
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(updateUserDetais, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateUserData(response?.data?.data));
        navigatePage(response?.data?.data);
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  function navigatePage(doctorData) {
    if (!doctorData.category_id) {
      navigate("/select-category");
    } else if (!doctorData.image || !doctorData.designation || !doctorData.degrees || !doctorData.experience_year || !doctorData.consultationFee) {
      navigate("/doctor-profile-setup/one");
    } else if (!doctorData.about_youself || !doctorData.educational_journey) {
      navigate("/doctor-profile-setup/two");
    } else if (doctorData.online_consultation == 0 && doctorData.clinic_consultation == 0) {
      navigate("/doctor-profile-setup/three");
    } else {
      navigate("/doctor-registration-success");
    }
  }

  return (
    <Wrapper>
      <Section topMd={200} topLg={150} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="col-md-4 g-2">
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            <PageHeader title={"Complete Registration"} />
            <p className="fs-md text-grey2 p-2"></p>
            <MobileNumberWithCountryCode selectedPhoneCountry={selectedPhoneCountry} onChange={setSelectedPhoneCountry} mobile={mobile} onMobileChange={setMobile} />
            <SelectField2 defaultValue={selectedCountry} label={"Select Country"} placeholder={"Select a country"} items={mapCountries} onChange={onSelectCountryItem} />
            <SelectField
              defaultValue={gender}
              label={"Select Gender"}
              items={[
                { label: "Male", value: 1 },
                { label: "Female", value: 0 },
              ]}
              onChange={(e) => setGender(e.target.value)}
            />

            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
